export default __webpack_public_path__ + "static/media/uiet.95a4c2c4.png";